var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('TopBarSection',{staticClass:"undo-redo-top-bar-section",attrs:{"border-left":true}},[_c('IconButton',{attrs:{"disabled":!_vm.canUndo,"icon":"UndoIcon","size":"18"},on:{"click":_vm.undo}}),_c('IconButton',{attrs:{"disabled":!_vm.canRedo,"icon":"RedoIcon","size":"18"},on:{"click":_vm.redo}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }